import { memo } from "react";
import TaskItemTemplate from "./TaskItemTemplate";

function TaskItem({
  taskKey,
  isOpen,
  isDone,
  isLocked,
  isOptional,
  hasMissingValue,
  linkedThoughtRecordKey,
  linkedMeditationRecordKey,
  setNumber,
  isConnectedUp,
  isConnectedDown,
}: {
  taskKey: string;
  isOpen: boolean;
  isDone: boolean;
  isLocked?: boolean;
  isOptional?: boolean;
  hasMissingValue?: boolean;
  linkedThoughtRecordKey?: string;
  linkedMeditationRecordKey?: string;
  setNumber?: number;
  isConnectedUp?: boolean;
  isConnectedDown?: boolean;
}) {
  return (
    <TaskItemTemplate
      key={taskKey}
      taskKey={taskKey}
      isOpen={isOpen}
      isDone={isDone}
      isLocked={isLocked}
      isOptional={isOptional}
      hasMissingValue={hasMissingValue}
      linkedThoughtRecordKey={linkedThoughtRecordKey}
      linkedMeditationRecordKey={linkedMeditationRecordKey}
      setNumber={setNumber}
      isConnectedUp={isConnectedUp}
      isConnectedDown={isConnectedDown}
    />
  );
}

export default memo(TaskItem);
